import React, { useEffect, useState } from 'react';
import privacyContent_zh from 'components/protocolContent/zh/privacyContent';
import privacyContent_zh_TW from 'components/protocolContent/zh-tw/privacyContent';
import privacyContent_kr from 'components/protocolContent/kr/privacyContent';
import privacyContent_en from 'components/protocolContent/en/privacyContent';
import privacyContent_jp from 'components/protocolContent/jp/privacyContent';
import styles from '@/pages/protocol/index.module.less';
import { GetStaticProps } from 'next';
import { loadTranslation } from '@/libs';
import { GlobalType } from '@/types/global';
import classNames from 'classnames';
import { useIsInternational } from '@/hooks/useIsInternational';
import Image from 'next/image';
import { LogoPath } from 'components/Header';

export const getStaticProps: GetStaticProps = async ctx => {
  const translation = await loadTranslation(
    ctx.locale!,
    process.env.NODE_ENV === 'production'
  );
  return {
    props: {
      translation,
    },
  };
};

const Privacy: React.FC = () => {
  const [showChild, setShowChild] = useState(false);
  const { lang } = useIsInternational();

  useEffect(() => {
    setShowChild(true);
  }, []);

  const title = {
    zh: '蛮啾隐私政策',
    ['zh-tw']: '隱私權保護政策',
    jp: 'プライバシーポリシー',
    en: 'Privacy Policy',
    kr: '개인정보처리방침',
  };

  const __html: Record<GlobalType.LangType, any> = {
    zh: privacyContent_zh,
    kr: privacyContent_kr,
    en: privacyContent_en,
    ['zh-tw']: privacyContent_zh_TW,
    jp: privacyContent_jp,
  };

  if (!showChild) {
    return <></>;
  }

  return (
    <div className={styles.protocol_container}>
      <div className={styles.protocol_content}>
        <div className={styles.protocol_title}>{title[lang]}</div>
        <article
          className={classNames([styles.mj_privacy_content])}
          dangerouslySetInnerHTML={{
            __html: __html[lang],
          }}
        />
        <div className={styles.protocol_footer}>
          <Image width={83} src={LogoPath} alt="Manjuu" />
        </div>
      </div>
    </div>
  );
};

export default Privacy;
